import React, { useEffect, useMemo, useState } from "react";

const FilterTextInput = ({
  name,
  label,
  placeholder = "",
  type = "text",
  currentValues = [],
  onChange = () => {},
  col = "col-md-3",
  disabled = false,
}) => {
  // derive initial value safely
  const initialValue = useMemo(() => {
    if (!Array.isArray(currentValues)) return "";
    const found = currentValues.find((v) => v && v[name] !== undefined);
    return found ? found[name] : "";
  }, [currentValues, name]);

  const [value, setValue] = useState(initialValue);

  // keep local state in sync if filters reset externally
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  // notify parent when value changes
  useEffect(() => {
    onChange(name, value);
  }, [name, value, onChange]);

  return (
    <div className={col}>
      <div className="form-group mb-lg-0">
        {label && <label className="tx-12 text-muted mb-1">{label}</label>}
        <input
          className="form-control"
          type={type}
          name={name}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          onChange={(e) => setValue(e.target.value)}
        />
      </div>
    </div>
  );
};

export default FilterTextInput;
